import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit, ViewChild, ElementRef  } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Q1Store } from '../../interfaces/game.interface';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-call-file-page',
  templateUrl: './call-file-page.component.html',
  styleUrls: ['./call-file-page.component.scss']
})
export class CallFilePageComponent implements OnInit, AfterViewInit {
  @Input() currentShop: string = '1';
  @Output() closeClick = new EventEmitter<string>();
  @Output() quarterEndTriggered = new EventEmitter<{
    success: boolean,
    correctSelections: number,
    incorrectIds: string[]
  }>();
  @ViewChild('swiperCallFile') swiper!: ElementRef<any>;

  chosenExisting: number = 0;
  chosenProspects: number = 0;
  numberShops$: Observable<number>;
  gridView: boolean = false;
  shops$: Observable<Q1Store[]>;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.shops$ = this.dataService.gameState$.pipe(
      map(state => {
        if (!state) return [];
        return Object.values(state.q1_stores);
      })
    );

    this.numberShops$ = this.shops$.pipe(
      map(shops => shops.length)
    );

    this.shops$.subscribe(shops => {
      this.calculateChosenShops(shops);
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.initializeSwiper(), 100);
  }

  initializeSwiper() {
    const swiperParams = {
      updateOnWindowResize: true,
      initialSlide: +this.currentShop - 1,
      loop: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loopAdditionalSlides: 1,
      loopPreventsSlide: true,
    };
  
    Object.assign(this.swiper.nativeElement, swiperParams);
    this.swiper.nativeElement.initialize();
  
    this.swiper.nativeElement.addEventListener('swiperslidechange', (event) => {
      this.currentShop = this.swiper.nativeElement.swiper.realIndex + 1; // ← Here's the fix
    });
  
    // Handle Angular change detection
    setTimeout(() => {
      this.swiper.nativeElement.swiper.update();
    });
  }
  
  prevShop() {
    this.swiper.nativeElement.swiper.slidePrev();
    this.currentShop = this.swiper.nativeElement.swiper.realIndex + 1;
  }
  
  nextShop() {
    this.swiper.nativeElement.swiper.slideNext();
    this.currentShop = this.swiper.nativeElement.swiper.realIndex + 1;
  }

  onCloseClick(): void {
    this.closeClick.emit(this.currentShop);
  }

  private calculateChosenShops(shops: Q1Store[]): void {
    this.chosenExisting = shops
      .filter(shop => shop.type === 'Existing Retailer' && shop.chosen)
      .length;

    this.chosenProspects = shops
      .filter(shop => shop.type === 'New Prospect' && shop.chosen)
      .length;
  }

  toString(i: number) {
    return String(i);
  }

  endQuarter() {
    this.dataService.concludeQuarterOne().then(res => {
      this.quarterEndTriggered.emit(res);
    }).catch(error => console.error(error));
  }
}
